import backendUrl from "./backendUrl";

// Coupon API endpoints
export const couponApi = {
  createCoupon: {
    url: `${backendUrl}/api/create-coupon`,
    method: "POST",
  },
  getAllCoupons: {
    url: `${backendUrl}/api/get-all-coupons`,
    method: "GET",
  },
  updateCoupon: {
    url: `${backendUrl}/api/update-coupon`,
    method: "PUT",
  },
  deleteCoupon: {
    url: `${backendUrl}/api/delete-coupon`,
    method: "DELETE",
  },
  validateCoupon: {
    url: `${backendUrl}/api/validate-coupon`,
    method: "POST",
  },
  applyCoupon: {
    url: `${backendUrl}/api/apply-coupon`,
    method: "POST",
  },
};
